import i18n from '../../i18n';

export const translations = {
  create: {
    label: i18n.t(`audit-management.action.table.create`),
    color: 'bg-success-subtle text-success',
  },
  delete: {
    label: i18n.t(`audit-management.action.table.delete`),
    color: 'bg-danger-subtle text-danger',
  },
  update: {
    label: i18n.t(`audit-management.action.table.update`),
    color: 'bg-warning-subtle text-warning',
  },
};
